/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilterView } from './FilterView';
import {
    FilterViewFromJSON,
    FilterViewFromJSONTyped,
    FilterViewToJSON,
} from './FilterView';

/**
 * 
 * @export
 * @interface CreateFilterView201Response
 */
export interface CreateFilterView201Response {
    /**
     * 
     * @type {FilterView}
     * @memberof CreateFilterView201Response
     */
    data?: FilterView;
}

/**
 * Check if a given object implements the CreateFilterView201Response interface.
 */
export function instanceOfCreateFilterView201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateFilterView201ResponseFromJSON(json: any): CreateFilterView201Response {
    return CreateFilterView201ResponseFromJSONTyped(json, false);
}

export function CreateFilterView201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFilterView201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FilterViewFromJSON(json['data']),
    };
}

export function CreateFilterView201ResponseToJSON(value?: CreateFilterView201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FilterViewToJSON(value.data),
    };
}

